import { Subscription } from 'rxjs';
import { Component, OnDestroy } from '@angular/core';
import { EntityService } from 'src/app/features/entity/services/entity.service';
import { UtilService } from '../services/util.service';


@Component({
  template: ''
})
// tslint:disable-next-line: component-class-suffix
export class CleanSubscriptions implements OnDestroy {

  constructor() { }

  private subs: Subscription[] = [];

  ngOnDestroy() {
    this.clearAllSubscriptions();
    this.onDestroy();
  }

  clearAllSubscriptions() {
    this.subs.forEach(s => s.unsubscribe());
  }

  set subscribe(action: Subscription) {
    this.subs.push(action);
  }


  onDestroy() {

  }

}
